<template>
  <div>
    <div class="topDiv">
      <span>是否打印所有内容？</span>
      <el-button @click="goBack">返 回</el-button>
      <el-button type="primary" v-print="printObj">打 印</el-button>
    </div>
    <div class="printContract">
      <div class="contentPrint" id="printContract">
        <div class="title">租金单列统计表</div>
        <el-table
            v-loading="loading"
            :data="tableData"
            :default-sort = "{prop: 'id', order: 'descending'}"
            style="width: 100%"
            :highlight-current-row="false">
          <el-table-column
              label="序号"
              type="index"
              width="50">
          </el-table-column>
          <template v-for="(item, index) in tableColumns">
            <el-table-column
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width">
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { queryExcelBuidingRental } from '@/api/statistics'

export default {
  name: 'printBuildingRent',
  data () {
    return {
      loading: false,
      printObj: {
        id: 'printContract',
        popTitle: '打印',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      buildingId: this.$route.query.buildingId,
      tableData: [],
      tableColumns: [
        {
          prop: 'companyName',
          label: '租赁单位名称',
          width: 110
        },
        {
          prop: 'buildingName',
          label: '楼宇名称'
        },
        {
          prop: 'roomNumber',
          label: '室号'
        },
        {
          prop: 'contractRentalArea',
          label: '面积'
        },
        {
          prop: 'daliyRental',
          label: '日租金'
        },
        {
          prop: 'annualRental',
          label: '年租金'
        },
        {
          prop: 'rentalPayCycle',
          label: '付款周期'
        },
        {
          prop: 'securityDeposit',
          label: '保证金'
        },
        {
          prop: 'contractPeriod',
          label: '合同期'
        },
        {
          prop: 'contractEndDate',
          label: '合同到期日',
          width: 100
        },
        {
          prop: 'remark',
          label: '备注',
          width: 110
        }
      ]
    }
  },
  components: {},
  mounted () {
    this.queryList()
  },
  methods: {
    // 查询
    async queryList () {
      let res = await queryExcelBuidingRental({
        buildingId: this.buildingId
      })
      if (res.code === 0) {
        this.tableData = res.result.records
      }
    },
    // 取消
    goBack () {
      this.$router.push('/report/buildingRent')
    }
  }
}
</script>

<style lang="scss" scoped>
  .topDiv{
    padding-left: .6rem;
    width: 10rem;
    margin: .25rem auto;
    font-size: .16rem;
    letter-spacing: .03rem;
  }
  .printContract{
    margin: 0 auto;
    width: 61%;
    /*background-color: #fff;*/
    .contentPrint{
      width: 100%;
      .title{
        letter-spacing: .03rem;
        font-size: .16rem;
        margin-bottom: .1rem;
        margin-top: .2rem;
      }
    }
  }

  /deep/.el-table td{
    text-align:center !important
  }

</style>
